module.exports = __webpack_public_path__ + "img/cg_sea1.cd950640.jpg";